export type OutboundSocialMessage
  = | { type: 'text', text: string }
    | {
      type: 'room_invite'
      roomCode: string
      caption?: string
    }

type PendingAttempt = {
  payloadKey: string
  clientMessageId: string
}

function normalizedPayloadKey(
  connectionId: string,
  payload: OutboundSocialMessage,
): string {
  return JSON.stringify(
    payload.type === 'text'
      ? [connectionId, payload.type, payload.text.trim()]
      : [
          connectionId,
          payload.type,
          payload.roomCode.trim(),
          payload.caption?.trim() || null,
        ],
  )
}

export class MessageSendAttemptTracker {
  private pending: PendingAttempt | null = null

  getOrCreate(
    connectionId: string,
    payload: OutboundSocialMessage,
    createId: () => string,
  ): string {
    const payloadKey = normalizedPayloadKey(connectionId, payload)
    if (this.pending?.payloadKey === payloadKey)
      return this.pending.clientMessageId

    const clientMessageId = createId()
    this.pending = { payloadKey, clientMessageId }
    return clientMessageId
  }

  invalidateIfPayloadChanged(
    connectionId: string,
    payload: OutboundSocialMessage | null,
  ): void {
    if (
      this.pending
      && (
        !payload
        || this.pending.payloadKey
        !== normalizedPayloadKey(connectionId, payload)
      )
    ) {
      this.pending = null
    }
  }

  markSucceeded(clientMessageId: string): void {
    if (this.pending?.clientMessageId === clientMessageId)
      this.pending = null
  }
}
